import type { FC } from 'react';
import PropTypes from 'prop-types';
import { useGetContentSlot } from '../../utils/api';
import { ContentSlotID } from '../../utils/api/ContentSlotID';
import { Content } from './Content';

interface Props {
    className?: string;
    contentSlotId: ContentSlotID;
}

export const ContentSlot: FC<Props> = ({ contentSlotId, className }) => {
    const contentSlot = useGetContentSlot(contentSlotId);
    return <Content serverHtml={contentSlot.data} className={className} />;
};

ContentSlot.propTypes = {
    contentSlotId: PropTypes.oneOf(Object.values(ContentSlotID) as ContentSlotID[]).isRequired,
    className: PropTypes.string,
};

ContentSlot.defaultProps = {
    className: undefined,
};
